import Field, { AggregationType, FieldType, fieldToOutputType } from "@dto/fields";
import { useModelStore } from "src/store";
import { CheckboxFilterValueEditor } from "./CheckboxFilterValueEditor";
import { ChoiceSelect } from "./ChoiceSelect";
import { CurrencyFilterValueEditor } from "./CurrencyFilterValueEditor";
import { DecimalFilterValueEditor } from "./DecimalFilterValueEditor";
import { NumberFilterValueEditor } from "./NumberFilterValueEditor";
import { PercentageFilterValueEditor } from "./PercentageFilterValueEditor";
import { TextFilterValueEditor } from "./TextFilterValueEditor";


type PrimitiveSelectProps = {
    pathKey: string | null;
    field: Field | null;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
}

export function PrimitiveSelect({ pathKey, field, value, disabled, onValueChange }: PrimitiveSelectProps) {

    const selectedView = useModelStore(state => state.selectedView);
    const fieldByKeys = useModelStore((state) => state.fieldByKeys);
    
    if (!pathKey) {
        return null;
    }

    if (!field) {
        return <TextFilterValueEditor key={selectedView?._key + "_null_field"} pathKey={pathKey} field={field} value={value} disabled={true} onValueChange={onValueChange} />;
    }
    const aggregation = selectedView?.aggregations?.get(pathKey) ?? field.aggregation ?? AggregationType.NO_AGGR; 
    const outputType = fieldToOutputType(field, aggregation, fieldByKeys);
    switch (outputType) {
        case FieldType.Text:
            return <TextFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.TextArea:
            return <TextFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Url:
            return <TextFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Number:
            return <NumberFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Boolean:
            return <CheckboxFilterValueEditor key={selectedView?._key + "_" + field._key} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Decimal:
            return <DecimalFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Percent:
            return <PercentageFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Devise:
            return <CurrencyFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={disabled} onValueChange={onValueChange} />
        case FieldType.Choice || FieldType.MultiChoice:
            return <ChoiceSelect key={selectedView?._key + "_" + field._key} field={field} value={value} disabled={disabled} onSelectionChange={onValueChange} />
        default:
            return <TextFilterValueEditor key={selectedView?._key + "_" + field._key} pathKey={pathKey} field={field} value={value} disabled={true} onValueChange={onValueChange} />
    }
}

